import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import ExamQuestionAddCard from "../../components/Exams/ExamQuestionAddCard"
import ExamProgressStepper from '../../components/Exams/ExamProgressStepper'
import { ExamAddHeader, WizardFooter } from '../../components/Exams/ExamAddWizard'
import { LINK_BTN } from '../../school_panel/components/ui/linkButton'

const ExamQuestionAdd = () => {
    const { examId } = useParams()
    return (
        <>
            <ExamAddHeader examId={examId} />
            <ExamProgressStepper current={2} />
            <ExamQuestionAddCard />
            <WizardFooter note="This page only previews questions; use Add exam to import, process and save them.">
                <Link to="/exams/exam-list" className={LINK_BTN}><ArrowLeft size={18} strokeWidth={1.8} aria-hidden />Exam list</Link>
            </WizardFooter>
        </>
    )
}

export default ExamQuestionAdd
